<script setup lang="ts">
useSeoMeta({
  title: "Veranstaltungstechnik Lungau – Bühne, Ton & Licht mieten",
  ogTitle: "Veranstaltungstechnik Lungau – Bühne, Ton & Licht mieten | Mody",
  description: "Professionelle Veranstaltungstechnik im Lungau: Bühne, Beschallung & Licht für Firmenfeiern, Konzerte und Events in Tamsweg, St. Michael und Mauterndorf. Mody Veranstaltungstechnik.",
  ogDescription: "Professionelle Veranstaltungstechnik im Lungau: Bühne, Beschallung & Licht für Firmenfeiern, Konzerte und Events in Tamsweg, St. Michael und Mauterndorf. Mody Veranstaltungstechnik.",
})

const localBusinessJsonLd = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Mody Veranstaltungstechnik",
  "url": "https://mody.at/veranstaltungstechnik-lungau",
  "telephone": "+43 664 2247433",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Flachau",
    "postalCode": "5542",
    "addressRegion": "Salzburg",
    "addressCountry": "AT",
    "streetAddress": "Ennspark 193"
  },
  "areaServed": {
    "@type": "AdministrativeArea",
    "name": "Lungau"
  },
  "description": "Professionelle Veranstaltungstechnik im Lungau – Bühne, Ton und Licht für Events in Tamsweg, St. Michael und Mauterndorf."
}

useHead({
  script: [
    { type: 'application/ld+json', innerHTML: localBusinessJsonLd }
  ]
})

const offerings = [
  { icon: 'pi pi-volume-up', title: 'Beschallung', description: 'Professionelle PA-Systeme für Hallen, Festzelte und Open-Air-Flächen im Lungau.' },
  { icon: 'pi pi-sun', title: 'Lichttechnik', description: 'Stimmungsvolle Beleuchtung und spektakuläre Lichtshows – für jeden Anlass das passende Konzept.' },
  { icon: 'pi pi-home', title: 'Bühne', description: 'Unser StageTruck und modulare Bühnensysteme – auch für Outdoor-Events in der Bergregion.' }
]

const events = ['Brauchtumsfeste', 'Vereinsfeste', 'Konzerte', 'Firmenfeiern', 'Hochzeiten', 'Dorffeste', 'Open-Air-Events', 'Stadtfeste', 'Sportveranstaltungen']
const places = ['Tamsweg', 'St. Michael im Lungau', 'Mauterndorf', 'Mariapfarr', 'Muhr', 'Ramingstein', 'Thomatal', 'Zederhaus']
</script>

<template>
  <LandingRegionalEventLanding
    kicker="Lungau"
    title="Veranstaltungstechnik Lungau"
    hero-description="Professionelle Bühne, Ton & Licht für Events im Lungau – in Tamsweg, St. Michael im Lungau, Mauterndorf und der gesamten Region."
    intro-heading="Euer Partner für Events im Lungau"
    :intro-paragraphs="[
      'Der Lungau ist eine der ursprünglichsten Regionen Österreichs – mit einem reichen Brauchtum und einer lebhaften Festkultur. Mody Veranstaltungstechnik erweitert sein Einzugsgebiet in den Lungau und beliefert nun auch Events in Tamsweg, St. Michael im Lungau, Mauterndorf und der gesamten Region.',
      'Von traditionellen Brauchtumsfesten bis zu modernen Firmenfeiern – wir bringen professionelle Veranstaltungstechnik in die Region.'
    ]"
    offerings-heading="Was wir im Lungau anbieten"
    :offerings="offerings"
    events-heading="Events, die wir im Lungau betreuen"
    :events="events"
    service-heading="Unsere Orte im Lungau"
    service-description="Wir betreuen Events im gesamten Lungau."
    :places="places"
    cta-heading="Jetzt Angebot für euer Lungau-Event anfragen"
    cta-description="Kostenlos & unverbindlich. Wir melden uns schnell zurück mit einem individuellen Angebot."
  />
</template>
